import { AppLayout } from '@/components/app-layout';
import { AppSumoGate } from '@/components/appsumo-gate.component';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { OnboardingCheck } from '@/components/onboarding-check.component';
import { RecordsTabsHeader } from '@/components/sidebar/tabs/records-tabs.component';
import { CompaniesListContainer } from '@/containers/companies/companies-list-container.component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/companies/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <Head heading='Companies' />
      <AuthCheck>
        <OnboardingCheck>
          <AppLayout variant='full-bleed'>
            <RecordsTabsHeader />
            <AppSumoGate label='Companies'>
              <CompaniesListContainer />
            </AppSumoGate>
          </AppLayout>
        </OnboardingCheck>
      </AuthCheck>
    </>
  );
}
